export default function MonogramSeal({ size = 140 }) {
  return (
    <div
      aria-hidden="true"
      className="relative grid place-items-center"
      style={{ width: size, height: size }}
    >
      {/* Outer rotating ring with text on path */}
      <svg
        className="seal-ring absolute inset-0 text-[var(--iw-gold)]"
        viewBox="0 0 140 140"
        width={size}
        height={size}
      >
        <defs>
          <path
            id="sealTextPath"
            d="M 70,70 m -58,0 a 58,58 0 1,1 116,0 a 58,58 0 1,1 -116,0"
          />
        </defs>
        <text
          fontFamily="Cormorant Garamond, serif"
          fontSize="9"
          letterSpacing="6"
          fill="currentColor"
          opacity="0.8"
        >
          <textPath href="#sealTextPath" startOffset="0">
            INVITATION WALA · BESPOKE DIGITAL INVITATIONS · EST 2024 ·
          </textPath>
        </text>
      </svg>
      {/* Inner seal */}
      <div
        className="relative grid place-items-center rounded-full"
        style={{
          width: size * 0.68,
          height: size * 0.68,
          border: "1px solid rgba(212,175,55,0.5)",
          background:
            "radial-gradient(circle, rgba(232,165,180,0.15) 0%, rgba(10,10,10,0.8) 70%)",
        }}
      >
        <span
          className="font-serif-display italic text-[var(--iw-gold)] leading-none"
          style={{
            fontFamily: "Cormorant Garamond, serif",
            fontSize: size * 0.36,
          }}
        >
          IW
        </span>
      </div>
    </div>
  );
}
